import { inject } from 'vue';

export function useLoading() {
    const loading = inject('loading');

    if (!loading) {
        throw new Error(
            'useLoading must be used within a component setup function and after the LoadingService is installed.'
        );
    }

    return loading;
}
